import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import I18nProvider from '@cloudscape-design/components/i18n';
import i18n from './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
        <I18nProvider locale={i18n.language} messages={[]}>
    
    <App />
    </I18nProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
